import * as PIXI from 'pixi.js';
import { populate } from 'populate';


const raw = /* 4@4!8|raw|8!4@ */ {
	"list": [
		{
			"x": 0,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0,
				"y": 0
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "5af1bfae-15fb-4272-b8bb-5918d2894a80",
			"parent": "",
			"name": "root",
			"type": "Container"
		},
		{
			"x": 0,
			"y": -471.6,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "9e43b965-13e0-498e-a724-36b250adcb97",
			"parent": "5af1bfae-15fb-4272-b8bb-5918d2894a80",
			"name": "",
			"type": "Text",
			"text": "LEADERBOARD",
			"localize": true,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 56,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": 0,
			"y": -365.40000000000003,
			"className": "",
			"pivot": {
				"x": 0,
				"y": 0
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "e0a78612-afa2-47b0-bb83-efb95233e6e7",
			"parent": "5af1bfae-15fb-4272-b8bb-5918d2894a80",
			"name": "score_0",
			"type": "Container"
		},
		{
			"x": -277.20000000000005,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "261c689d-41d5-466d-a955-ff9c765fa1e0",
			"parent": "e0a78612-afa2-47b0-bb83-efb95233e6e7",
			"name": "score_pos_0",
			"type": "Text",
			"text": "1.",
			"localize": false,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": -41.400000000000034,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "1141a62a-8f8a-4c24-ba89-cb0bd47d4e23",
			"parent": "e0a78612-afa2-47b0-bb83-efb95233e6e7",
			"name": "score_name_0",
			"type": "Text",
			"text": "%%%",
			"localize": false,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": 235.8,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "7a863d2c-ae4a-4183-bd3c-a6b2f0b937c9",
			"parent": "e0a78612-afa2-47b0-bb83-efb95233e6e7",
			"name": "score_points_0",
			"type": "Text",
			"text": "%%%",
			"localize": false,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": 0,
			"y": -291.6,
			"className": "",
			"pivot": {
				"x": 0,
				"y": 0
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "b66e6a92-6afc-4302-9eef-a71d2e1468e4",
			"parent": "5af1bfae-15fb-4272-b8bb-5918d2894a80",
			"name": "score_1",
			"type": "Container"
		},
		{
			"x": -277.20000000000005,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "26b3b284-70ca-4ac3-85cd-2cdbb7a041e5",
			"parent": "b66e6a92-6afc-4302-9eef-a71d2e1468e4",
			"name": "score_pos_1",
			"type": "Text",
			"text": "2.",
			"localize": false,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": -41.400000000000034,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "f9bb2da2-36b2-4027-9bc7-60098f820ec8",
			"parent": "b66e6a92-6afc-4302-9eef-a71d2e1468e4",
			"name": "score_name_1",
			"type": "Text",
			"text": "%%%",
			"localize": false,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": 235.8,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "443f1b85-3f77-4438-a4ed-2d69189f0863",
			"parent": "b66e6a92-6afc-4302-9eef-a71d2e1468e4",
			"name": "score_points_1",
			"type": "Text",
			"text": "%%%",
			"localize": false,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": 0,
			"y": -217.8,
			"className": "",
			"pivot": {
				"x": 0,
				"y": 0
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "4dfef93f-51cc-4677-bf09-e8b2b36bfa02",
			"parent": "5af1bfae-15fb-4272-b8bb-5918d2894a80",
			"name": "score_2",
			"type": "Container"
		},
		{
			"x": -277.20000000000005,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "caff5d6a-49ee-44cb-a16d-46c4e44f6405",
			"parent": "4dfef93f-51cc-4677-bf09-e8b2b36bfa02",
			"name": "score_pos_2",
			"type": "Text",
			"text": "3.",
			"localize": false,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": -41.400000000000034,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "4930a326-1b50-4322-8e84-b5a9e6aabbc1",
			"parent": "4dfef93f-51cc-4677-bf09-e8b2b36bfa02",
			"name": "score_name_2",
			"type": "Text",
			"text": "%%%",
			"localize": false,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": 235.8,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "a768c3ba-45fc-4e01-ab17-acb8820c6ef1",
			"parent": "4dfef93f-51cc-4677-bf09-e8b2b36bfa02",
			"name": "score_points_2",
			"type": "Text",
			"text": "%%%",
			"localize": false,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": 0,
			"y": -142.20000000000005,
			"className": "",
			"pivot": {
				"x": 0,
				"y": 0
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "51a2b315-e918-440a-8883-9fbc44a7cc42",
			"parent": "5af1bfae-15fb-4272-b8bb-5918d2894a80",
			"name": "score_3",
			"type": "Container"
		},
		{
			"x": -277.20000000000005,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "d304c5c6-da12-4f3c-8214-fa8c8b4686f8",
			"parent": "51a2b315-e918-440a-8883-9fbc44a7cc42",
			"name": "score_pos_3",
			"type": "Text",
			"text": "4.",
			"localize": false,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": -41.400000000000034,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "cb0b29a8-e5ba-4562-89a9-1b4d0c675aab",
			"parent": "51a2b315-e918-440a-8883-9fbc44a7cc42",
			"name": "score_name_3",
			"type": "Text",
			"text": "%%%",
			"localize": false,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": 235.8,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "01bdaa08-893d-4a3f-ba48-b565fcc0e83c",
			"parent": "51a2b315-e918-440a-8883-9fbc44a7cc42",
			"name": "score_points_3",
			"type": "Text",
			"text": "%%%",
			"localize": false,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": 0,
			"y": -68.39999999999998,
			"className": "",
			"pivot": {
				"x": 0,
				"y": 0
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "cf1d2ffd-4b1b-4836-afa1-464fcaa4a239",
			"parent": "5af1bfae-15fb-4272-b8bb-5918d2894a80",
			"name": "score_4",
			"type": "Container"
		},
		{
			"x": -277.20000000000005,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "fd33ae79-0763-4794-88b0-5ee47f841aea",
			"parent": "cf1d2ffd-4b1b-4836-afa1-464fcaa4a239",
			"name": "score_pos_4",
			"type": "Text",
			"text": "5.",
			"localize": false,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": -41.400000000000034,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "b9601d76-6fff-4865-9e10-3ec82d2f1da5",
			"parent": "cf1d2ffd-4b1b-4836-afa1-464fcaa4a239",
			"name": "score_name_4",
			"type": "Text",
			"text": "%%%",
			"localize": false,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": 235.8,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "06aa5647-8a17-4a96-98e1-795669fe908d",
			"parent": "cf1d2ffd-4b1b-4836-afa1-464fcaa4a239",
			"name": "score_points_4",
			"type": "Text",
			"text": "%%%",
			"localize": false,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": 0,
			"y": 5.399999999999977,
			"className": "",
			"pivot": {
				"x": 0,
				"y": 0
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "ca7091ba-216f-46d8-92cc-de3f16224615",
			"parent": "5af1bfae-15fb-4272-b8bb-5918d2894a80",
			"name": "score_5",
			"type": "Container"
		},
		{
			"x": -277.20000000000005,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "7f7df437-b3ad-4600-8f32-c14b0a3edeeb",
			"parent": "ca7091ba-216f-46d8-92cc-de3f16224615",
			"name": "score_pos_5",
			"type": "Text",
			"text": "6.",
			"localize": false,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": -41.400000000000034,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "65e951ed-f778-4221-ad09-25629a64d130",
			"parent": "ca7091ba-216f-46d8-92cc-de3f16224615",
			"name": "score_name_5",
			"type": "Text",
			"text": "%%%",
			"localize": false,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": 235.8,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "cad17e4f-6f34-4344-8743-182f57f1c2b4",
			"parent": "ca7091ba-216f-46d8-92cc-de3f16224615",
			"name": "score_points_5",
			"type": "Text",
			"text": "%%%",
			"localize": false,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": 0,
			"y": 81,
			"className": "",
			"pivot": {
				"x": 0,
				"y": 0
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "e170be53-bebd-4de1-b13c-dcd4e4ecad6f",
			"parent": "5af1bfae-15fb-4272-b8bb-5918d2894a80",
			"name": "score_6",
			"type": "Container"
		},
		{
			"x": -277.20000000000005,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "267d7f08-f380-4c46-b04b-b2a4620d1a7e",
			"parent": "e170be53-bebd-4de1-b13c-dcd4e4ecad6f",
			"name": "score_pos_6",
			"type": "Text",
			"text": "7.",
			"localize": false,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": -41.400000000000034,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "bf395020-dbb1-4bbd-9292-c0c351642f31",
			"parent": "e170be53-bebd-4de1-b13c-dcd4e4ecad6f",
			"name": "score_name_6",
			"type": "Text",
			"text": "%%%",
			"localize": false,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": 235.8,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "19cfef23-20b1-46f3-94e3-8465a06171f5",
			"parent": "e170be53-bebd-4de1-b13c-dcd4e4ecad6f",
			"name": "score_points_6",
			"type": "Text",
			"text": "%%%",
			"localize": false,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": 0,
			"y": 154.79999999999995,
			"className": "",
			"pivot": {
				"x": 0,
				"y": 0
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "ab95de88-080e-4b10-97fe-4e9234cbad7a",
			"parent": "5af1bfae-15fb-4272-b8bb-5918d2894a80",
			"name": "score_7",
			"type": "Container"
		},
		{
			"x": -277.20000000000005,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "f09e5119-afa0-4f93-b156-f45f1e507939",
			"parent": "ab95de88-080e-4b10-97fe-4e9234cbad7a",
			"name": "score_pos_7",
			"type": "Text",
			"text": "8.",
			"localize": false,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": -41.400000000000034,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "242795c5-7121-4809-b979-dde98b72265a",
			"parent": "ab95de88-080e-4b10-97fe-4e9234cbad7a",
			"name": "score_name_7",
			"type": "Text",
			"text": "%%%",
			"localize": false,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": 235.8,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "0c62432c-24c5-4b37-a11e-95dd6c352035",
			"parent": "ab95de88-080e-4b10-97fe-4e9234cbad7a",
			"name": "score_points_7",
			"type": "Text",
			"text": "%%%",
			"localize": false,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": 0,
			"y": 228.60000000000002,
			"className": "",
			"pivot": {
				"x": 0,
				"y": 0
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "dd859fec-2af4-41af-bbcc-cd3d9f7af2e0",
			"parent": "5af1bfae-15fb-4272-b8bb-5918d2894a80",
			"name": "score_8",
			"type": "Container"
		},
		{
			"x": -277.20000000000005,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "78974cd7-effc-4ecb-abb8-87a8ff3c9d52",
			"parent": "dd859fec-2af4-41af-bbcc-cd3d9f7af2e0",
			"name": "score_pos_8",
			"type": "Text",
			"text": "9.",
			"localize": false,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": -41.400000000000034,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "e7181e12-b563-477b-98e8-4795fd077de6",
			"parent": "dd859fec-2af4-41af-bbcc-cd3d9f7af2e0",
			"name": "score_name_8",
			"type": "Text",
			"text": "%%%",
			"localize": false,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": 235.8,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "677b128f-f4c6-4a50-a8f2-f4fcc25da2d5",
			"parent": "dd859fec-2af4-41af-bbcc-cd3d9f7af2e0",
			"name": "score_points_8",
			"type": "Text",
			"text": "%%%",
			"localize": false,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": 0,
			"y": 304.19999999999993,
			"className": "",
			"pivot": {
				"x": 0,
				"y": 0
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "499c3e1d-3f52-45f8-be55-4e54da4984ee",
			"parent": "5af1bfae-15fb-4272-b8bb-5918d2894a80",
			"name": "score_9",
			"type": "Container"
		},
		{
			"x": -266.40000000000003,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "a77555b7-f859-4ef4-8e8a-d47bfe32a59f",
			"parent": "499c3e1d-3f52-45f8-be55-4e54da4984ee",
			"name": "score_pos_9",
			"type": "Text",
			"text": "10.",
			"localize": false,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": -41.4,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "7cc6219e-7f01-472f-8a52-c5830bafea93",
			"parent": "499c3e1d-3f52-45f8-be55-4e54da4984ee",
			"name": "score_name_9",
			"type": "Text",
			"text": "%%%",
			"localize": false,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": 239.40000000000003,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "d777367a-121d-43f1-80a8-a575dabff3a0",
			"parent": "499c3e1d-3f52-45f8-be55-4e54da4984ee",
			"name": "score_points_9",
			"type": "Text",
			"text": "%%%",
			"localize": false,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		},
		{
			"x": 0,
			"y": 448.20000000000005,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": true,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "c428be00-e8b2-49cb-bb9e-647c2c048215",
			"parent": "5af1bfae-15fb-4272-b8bb-5918d2894a80",
			"name": "continueButton",
			"type": "Sprite",
			"texture": "Touch_To_Continue_Button",
			"tint": 16777215
		},
		{
			"x": 0,
			"y": 0,
			"className": "",
			"pivot": {
				"x": 0.5,
				"y": 0.5
			},
			"anchor": {
				"x": 0.5,
				"y": 0.5
			},
			"scale": {
				"x": 1,
				"y": 1
			},
			"angle": 0,
			"alpha": 1,
			"visible": true,
			"blendMode": 0,
			"interactive": false,
			"buttonMode": false,
			"hitArea": {
				"type": "None"
			},
			"id": "c1b2e470-384c-4d01-8eeb-53f8329e69b7",
			"parent": "c428be00-e8b2-49cb-bb9e-647c2c048215",
			"name": "",
			"type": "Text",
			"text": "Play Again",
			"localize": true,
			"maxWidth": 0,
			"maxHeight": 0,
			"maxFontSize": 0,
			"icons": [],
			"style": {
				"fontSize": 42,
				"fontWeight": "normal",
				"fontFamily": "Futura-Bold",
				"fill": "white",
				"stroke": "black",
				"strokeThickness": 0,
				"align": "left",
				"wordWrap": false,
				"wordWrapWidth": 100,
				"breakWords": false,
				"lineHeight": 0,
				"padding": 5,
				"fontStyle": "normal",
				"dropShadow": false,
				"dropShadowAlpha": 1,
				"dropShadowAngle": 0,
				"dropShadowBlur": 0,
				"dropShadowColor": "black",
				"dropShadowDistance": 5,
				"leading": 0,
				"lineJoin": "round",
				"miterLimit": 10,
				"trim": false,
				"textBaseline": "alphabetic",
				"whiteSpace": "pre",
				"fontVariant": "normal",
				"letterSpacing": 0
			}
		}
	],
	"x": 50,
	"y": 50,
	"width": 415,
	"height": 647,
	"handleResize": true
}; /* 4@4!8|raw|8!4@ */

type Filter = Partial<{
	root: boolean;
	continueButton: boolean;
}>;

class Layout {
	public readonly root: PIXI.Container;
	public readonly continueButton: PIXI.Sprite;

	constructor(filter?: Filter) {
		populate(this, raw, filter);
	}
}

export { Layout, Filter, raw };
